<div>
  <h2 mat-dialog-title>{{ header }}</h2>
  <mat-dialog-content>
    <mat-label>{{ message }}</mat-label>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-spacer"></div>
    <button mat-raised-button class="submit-button" [mat-dialog-close]="true">ตกลง</button>
  </mat-dialog-actions>
</div>
